(function () {
  const gridClass = 'leving-swym-product-grid';
  const hiddenClass = 'leving-swym-default-hidden';

  const formatMoney = (cents) => {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, window.theme?.moneyFormat || window.money_format || '€{{amount}}');
    }

    return new Intl.NumberFormat(document.documentElement.lang || 'en', {
      style: 'currency',
      currency: window.Shopify?.currency?.active || 'EUR'
    }).format((Number(cents) || 0) / 100);
  };

  const normalizeProductUrl = (url) => {
    if (!url) return '';

    try {
      return new URL(url, window.location.origin).pathname;
    } catch (error) {
      return url;
    }
  };

  const getProductJsonUrl = (item) => {
    const productUrl = normalizeProductUrl(item.du || item.product_url || item.url);
    if (!productUrl) return null;

    return `${productUrl.split('?')[0]}.js`;
  };

  const imageMarkup = (product) => {
    const images = (product.images || []).slice(0, 2);

    return images.map((image, index) => {
      const src = typeof image === 'string' ? image : image.src;
      const alt = product.title || '';

      return `
        <img
          src="${src}"
          alt="${alt.replace(/"/g, '&quot;')}"
          class="motion-reduce"
          loading="lazy"
          width="533"
          height="533"
          data-image-index="${index}"
        >
      `;
    }).join('');
  };

  const priceMarkup = (product, selectedVariant) => {
    const variants = product.variants || [];
    const minimumPrice = product.price_min || product.price || selectedVariant.price || 0;
    const selectedVariantOnSale = Number(selectedVariant.compare_at_price) > Number(selectedVariant.price);
    const minimumSaleVariant = variants.find((variant) =>
      Number(variant.price) === Number(minimumPrice) && Number(variant.compare_at_price) > Number(variant.price)
    );
    const anySaleVariant = variants.find((variant) =>
      Number(variant.compare_at_price) > Number(variant.price)
    );
    const saleVariant = selectedVariantOnSale ? selectedVariant : minimumSaleVariant || anySaleVariant;
    const price = saleVariant?.price || minimumPrice;
    const compareAtPrice = saleVariant?.compare_at_price || 0;

    if (Number(compareAtPrice) > Number(price)) {
      return `
        <span class="c-product-card__price c-product-card__price--sale">
          <span class="c-product-card__sale-price">From ${formatMoney(price)}</span>
          <s class="c-product-card__compare-price">${formatMoney(compareAtPrice)}</s>
        </span>
      `;
    }

    return `
      <span class="c-product-card__price">
        From ${formatMoney(price)}
      </span>
    `;
  };

  const renderCard = (product, item) => {
    const selectedVariant = product.variants?.find((variant) => String(variant.id) === String(item.epi)) || product.variants?.[0] || {};
    const productUrl = normalizeProductUrl(item.du || product.url || `/products/${product.handle}`);

    return `
      <c-product-card class="c-product-card"
        data-variant-id="${selectedVariant.id || item.epi || ''}"
        data-product-id="${product.id || item.empi || ''}"
        data-product-url="${window.location.origin}${productUrl}"
        data-open-wishlist="false"
      >
        <a href="${productUrl}" class="c-product-card__image">
          ${imageMarkup(product)}
        </a>

        <div class="c-product-card__tags">
          ${(product.tags || []).map((tag) => `<div class="c-product-card__tag">${tag}</div>`).join('')}
        </div>

        <button
          class="c-product-card__wish-button js-product-card__wish-button is-active"
          type="button"
          aria-label="${(product.title || '').replace(/"/g, '&quot;')} Wishlist Button"
          data-variant-id="${selectedVariant.id || item.epi || ''}"
          data-product-id="${product.id || item.empi || ''}"
          data-product-url="${window.location.origin}${productUrl}"
        >
          <span class="icon-wishlist"><svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none"><path d="M20 33.5s-1.1-1-2.65-2.35C10.7 25.35 6 21.25 6 15.7 6 11.6 9.2 8.5 13.25 8.5c2.35 0 4.65 1.1 6.15 2.85C20.9 9.6 23.2 8.5 25.55 8.5 29.6 8.5 32.8 11.6 32.8 15.7c0 5.55-4.7 9.65-11.35 15.45C21.1 31.5 20 33.5 20 33.5Z" stroke="currentColor" stroke-width="1.7" fill="none"/></svg></span>
          <span class="icon-wishlist-fill"><svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none"><path d="M20 33.5s-1.1-1-2.65-2.35C10.7 25.35 6 21.25 6 15.7 6 11.6 9.2 8.5 13.25 8.5c2.35 0 4.65 1.1 6.15 2.85C20.9 9.6 23.2 8.5 25.55 8.5 29.6 8.5 32.8 11.6 32.8 15.7c0 5.55-4.7 9.65-11.35 15.45C21.1 31.5 20 33.5 20 33.5Z" stroke="currentColor" stroke-width="1.7" fill="currentColor"/></svg></span>
        </button>

        <a class="c-product-card__title-link" href="${productUrl}">
          <h2 class="c-product-card__title" data-title="${(product.title || '').replace(/"/g, '&quot;')}">
            ${product.title || ''}
          </h2>
        </a>

        ${priceMarkup(product, selectedVariant)}
      </c-product-card>
    `;
  };

  const hideSwymGrid = () => {
    document.querySelectorAll('.swym-ui-component .swym-wishlist-grid').forEach((grid) => {
      grid.classList.add(hiddenClass);
    });
  };

  const mountGrid = (html) => {
    const swymPage = document.querySelector('.swym-ui-component.swym-wishlist-page') || document.querySelector('.swym-ui-component');
    if (!swymPage || !html) return;

    let grid = document.querySelector(`.${gridClass}`);
    if (!grid) {
      grid = document.createElement('div');
      grid.className = gridClass;

      const titleBar = swymPage.querySelector('.swym-wishlist-container-title-bar') || swymPage.querySelector('.swym-wishlist-detail-header');
      if (titleBar && titleBar.parentNode) {
        titleBar.parentNode.insertBefore(grid, titleBar.nextSibling);
      } else {
        swymPage.appendChild(grid);
      }
    }

    grid.innerHTML = html;
    hideSwymGrid();
  };

  const renderWishlist = async (list) => {
    const items = list?.listcontents || [];
    if (!items.length) return;

    const cards = await Promise.all(items.map(async (item) => {
      const productJsonUrl = getProductJsonUrl(item);
      if (!productJsonUrl) return '';

      try {
        const response = await fetch(productJsonUrl);
        if (!response.ok) return '';

        const product = await response.json();
        return renderCard(product, item);
      } catch (error) {
        console.error('Could not render wishlist product card', error);
        return '';
      }
    }));

    mountGrid(cards.join(''));
  };

  const renderCurrentWishlist = () => {
    if (window.apps?.wishlist?.list) {
      renderWishlist(window.apps.wishlist.list);
    }
  };

  const unhideSwymGrid = () => {
    document.querySelectorAll(`.${hiddenClass}`).forEach((grid) => {
      grid.classList.remove(hiddenClass);
    });
  };

  const removeWishlistCard = (button) => {
    const card = button.closest('c-product-card');
    const product = {
      epi: button.dataset.variantId || card?.dataset.variantId,
      empi: button.dataset.productId || card?.dataset.productId,
      du: button.dataset.productUrl || card?.dataset.productUrl,
    };

    if (!window.apps?.wishlist?.listId || !window.SwymCallbacks || !card) return;

    window.SwymCallbacks.push((swat) => {
      swat.deleteFromList(window.apps.wishlist.listId, product, () => {
        card.remove();
        publish?.('wishlist-remove-product', product);

        const grid = document.querySelector(`.${gridClass}`);
        if (grid && !grid.querySelector('c-product-card')) {
          grid.remove();
          unhideSwymGrid();
        }
      }, (error) => {
        console.error('Error while deleting wishlist product', error);
      });
    });
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest(`.${gridClass} .js-product-card__wish-button`);
    if (!button) return;

    event.preventDefault();
    event.stopPropagation();
    removeWishlistCard(button);
  });

  if (typeof subscribe === 'function') {
    subscribe('wishlist-loaded', renderWishlist);
  }

  window.SwymCallbacks = window.SwymCallbacks || [];
  window.SwymCallbacks.push(() => setTimeout(renderCurrentWishlist, 250));
  document.addEventListener('DOMContentLoaded', () => setTimeout(renderCurrentWishlist, 500));
})();
